import { executeRequest } from "@/common/utils/http/httpClient";
import { getCurrentEnvironmentVariables } from "@/lib/CONSTANTS";
import { endpointMapper } from "@/common/service/endpoint.map.js";
import { replaceAllMatchPattern } from "@/common/utils/generic/commonHelper.js";
import { getEnvironmentVariables } from "@/common/utils/env/envSettings.js";

const envSpecificApiDomain = getCurrentEnvironmentVariables().apiDomain;
const subPath = "v1";
const userApiPath = `${replaceAllMatchPattern(envSpecificApiDomain[subPath], endpointMapper[subPath].user)}`;

/**
 * getUserDetails
 * @description: Function will trigger async call to get the user details
 * @returns: User Details
 * @param {*}
 */
const getUserDetails = async data => {
  if (getEnvironmentVariables().label === "localhost") {
    data = "Gulshan.Kumar@maersk.com"; //Temp: setting this up for now, untill rest of the team members emailID allows access
  }
  //we will use these methods in store actions
  const url = `${userApiPath}/user/${data}`;

  return executeRequest({
    url,
    method: "GET"
  });
};

/**
 * getUseGroupList
 * @description: Function will trigger async call to get the user group List data
 * @returns: User Group List
 * @param {*}
 */
const getUserGroupList = async () => {
  //we will use these methods in store actions
  const url = `${userApiPath}/usergroup`;

  return executeRequest({
    url,
    method: "GET"
  });
};

export { getUserGroupList, getUserDetails };
